/**
 * EnergyConnect.WebApi | v1
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const AssetType = {
    NotSpecified: 'NotSpecified',
    SteamTurbineBackPressureMode: 'SteamTurbineBackPressureMode',
    Gasturbine: 'Gasturbine',
    CombinedCycle: 'CombinedCycle',
    CombustionEngineGas: 'CombustionEngineGas',
    SteamTurbineWithCondensation: 'SteamTurbineWithCondensation',
    Boiler: 'Boiler',
    StirlingEngine: 'StirlingEngine',
    PermanentConnectedElectricalEnergyStorageFacilities: 'PermanentConnectedElectricalEnergyStorageFacilities',
    TemporaryConnectedElectricalEnergyStorageFacilities: 'TemporaryConnectedElectricalEnergyStorageFacilities',
    FuelCells: 'FuelCells',
    PhotovoltaicCells: 'PhotovoltaicCells',
    WindTurbines: 'WindTurbines',
    HydroelectricPower: 'HydroelectricPower',
    WavePower: 'WavePower',
    MixedProduction: 'MixedProduction',
    ProductionWithElectricalEnergyStorageFacilities: 'ProductionWithElectricalEnergyStorageFacilities',
    PowerToX: 'PowerToX',
    RegenerativeDemandFacility: 'RegenerativeDemandFacility',
    CombustionEngineDiesel: 'CombustionEngineDiesel',
    CombustionEngineBio: 'CombustionEngineBio',
    UnknownTecnology: 'UnknownTecnology',
} as const;
export type AssetType = typeof AssetType[keyof typeof AssetType];

